import React from 'react';
import { toast, Slide } from 'react-toastify';

import ToastContent from '@/components/ToastContent';
import { ProtocoloExecutado } from '@/models/ProtocoloExecutado';

export function notifyFinalizacao(protocolo: ProtocoloExecutado): void {
  toast.dark(
    () => (
      <ToastContent>
        <p>
          Você finalizou o protocolo de <strong>{protocolo.nome}</strong>
        </p>
      </ToastContent>
    ),
    {
      closeButton: false,
      transition: Slide,
      position: 'bottom-left',
    },
  );
}
